{
  "bag": "Sac",
  "bag_in_box": "Cubi",
  "bottle": "Bouteille",
  "box": "Boîte",
  "carton": "Brique",
  "cup": "Pot plastique",
  "jar": "Pot verre",
  "pack": "Pack",
  "piece": "Pièce",
  "slice": "Tranche",
  "tin": "Bidon",
  "tube": "Tube",
  "box_set": "Coffret",
  "spray": "Spray",
  "weight": "Poids",
  "flask": "Flacon",
  "sachet": "Sachet",
  "tray": "Barquette",
  "keg": "Fût",
  "bulk": "Vrac",
  "unit_one": "unité",
  "unit_other": "unités",
  "per_unit": "À l'unité",
  "base_unit": "Unité de base",
  "case": "Colis",
  "pallet": "Palette",
  "of": "de",
  "crate": "Caisse",
  "can": "Canette",
  "display": "Présentoir",
  "sack": "Sac",
  "net": "Filet",
  "half_case": "Demi-colis",
  "tub": "Bac"
}
